import * as React from 'react';
import { useSelector } from 'react-redux';

import { getButtonTextByReferrer, TBackBtnTexts } from './getButtonTextByReferrer';
import { selectPage } from '../../../selectors/selectPage';

export const useButtonProps = (backBtnTexts: TBackBtnTexts) => {
  const { referrer } = useSelector(selectPage);
  const text = React.useMemo(() => {
    return getButtonTextByReferrer({ referrer, backBtnTexts });
  }, [referrer, backBtnTexts]);

  return { href: referrer, text };
};
